import type { Classroom, ClassroomSection, Maybe } from '@/types/composition-functions';

export function getClassroomSectionLabel(
  cs: Maybe<ClassroomSection>,
  classroom?: Maybe<Classroom>,
  schoolType?: string | null,
): string {
  if (!cs) return '';

  if (cs.name) return cs.name;

  const classroomName = classroom?.name ?? cs.classroom?.name;
  if (!classroomName) return '';

  if (schoolType?.toLowerCase() === 'tertiary') {
    return `${classroomName} Level`;
  }

  const sectionName = cs.section?.name;
  if (sectionName) {
    return `${classroomName} ${sectionName}`;
  }

  return classroomName;
}

export function buildClassroomSectionOptions(
  classrooms: Maybe<Classroom>[] | undefined,
  schoolType?: string | null,
): { label: string; value: string }[] {
  const opts: { label: string; value: string }[] = [];

  if (!classrooms) return opts;

  for (const c of classrooms) {
    if (!c?.classroomSections?.length) continue;

    for (const cs of c.classroomSections) {
      if (!cs) continue;
      opts.push({
        label: getClassroomSectionLabel(cs, c, schoolType),
        value: cs.id,
      });
    }
  }

  return opts;
}
